export enum LessonRecurringOptionEnum {
    Never = 1,
    Daily = 2,
    Weekly = 3,
    Fortnightly = 4,
}